<app-device-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="header"
  [overlayType]="availableOverlays.RefrigerantCircuit"
  [refrigerantCircuitId]="refrigerantCircuitId"
  [deviceSelectId]="deviceSelectId"
>
  <!-- compressor status -->
  <app-feature-tile
    data-at-refrigerant-circuit-panel-feature="compressor"
    *ngIf="refrigerantCircuitStatus$ | async | ready as feature"
    feature
    [error]="feature | error"
    [label]="'+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.STATUS.LABEL' | translate"
    [value]="
      feature.properties?.active?.value
        | booleanSuffix
          : [
              customTranslationsService.STATE.on | translate,
              customTranslationsService.STATE.off | translate
            ]
    "
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!--heating.compressors.0.heat.production.current/value-->
  <app-feature-tile
    *ngIf="currentThermalPower$ | async as feature"
    data-at-heating-compressors-0-heat-production-current
    feature
    [label]="
      '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.CURRENT_THERMAL_POWER.LABEL' | translate
    "
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature + '/value'"
  >
  </app-feature-tile>

  <ng-container feature *ngIf="refrigerantCircuitStatistics$ | async | ready as feature">
    <!-- hours -->
    <app-feature-tile
      data-at-refrigerant-circuit-panel-feature="hours"
      feature
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOURS.LABEL' | translate"
      value="{{ feature.properties?.hours?.value | toFixed: 0 }} {{ feature | unit: 'hours' }}"
      [attr.data-feature]="feature.feature + '/hours'"
    ></app-feature-tile>

    <!-- runs -->
    <app-feature-tile
      data-at-refrigerant-circuit-panel-feature="runs"
      feature
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.RUNS.LABEL' | translate"
      [value]="feature?.properties?.starts?.value | toFixed: 0"
      [attr.data-feature]="feature.feature + '/starts'"
    ></app-feature-tile>
  </ng-container>

  <!-- spaceFrostProtection and frostProtection -->
  <ng-container
    feature
    *ngIf="(spaceFrostProtection$ | async | ready) || (frostProtection$ | async | ready)"
  >
    <app-feature-tile
      data-at-refrigerant-circuit-panel-feature="dhwFrostProtection"
      feature
      [label]="dhwAndSpaceFrostProtection.status"
      [value]="dhwAndSpaceFrostProtection.value"
      data-feature="heating.dhw.dhwCylinder.frostprotection"
    ></app-feature-tile>
  </ng-container>

  <!-- heating.compressors.0.speed.current -->
  <!-- value2 doesn't work properly with suffix pipe -->
  <app-feature-tile
    *ngIf="compressorRPM$ | async as feature"
    feature
    data-at-compressors-speed.current
    [label]="'+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.COMPRESSOR_RPM' | translate"
    value="{{ feature?.properties?.value?.value | suffix: suffix.rotationPerMinute }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
</app-device-features-container>
